// Centralized option lists + tiny localStorage helpers

export const CONTRACT_TYPES = [
  'NA', 'Lump Sum', 'Per Unit', 'Gatewood', 'Time & Materials'
] as const

export const HARVEST_TYPES = [
  'Clearcut', 'Thin', 'First Thinning', 'Second Thinning', 'Shelterwood', 'Select Cut', 'Chip-N-Saw'
] as const

export const CERTIFICATIONS = [
  'SFI', 'FSC', 'PEFC', 'Other'
] as const

// 50 states (abbr)
export const STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
] as const

// -------- suggestion helpers (persist simple strings) --------
function lsKey(key:string){ return `opts:${key}:v1` }

export function getOptionsLS(key:string, seed:string[]=[]): string[] {
  try {
    const raw = localStorage.getItem(lsKey(key))
    const stored: string[] = raw ? JSON.parse(raw) : []
    const set = new Set<string>([...seed, ...stored].map(s => s.trim()).filter(Boolean))
    return [...set].sort((a,b)=>a.localeCompare(b))
  } catch {
    return seed
  }
}

export function addOptionLS(key:string, value:string){
  const v = value.trim()
  if (!v) return
  const raw = localStorage.getItem(lsKey(key))
  const arr: string[] = raw ? JSON.parse(raw) : []
  if (!arr.includes(v)){
    arr.push(v)
    localStorage.setItem(lsKey(key), JSON.stringify(arr))
  }
}
